export enum EventHomeViews {
  'STATS',
  'LOGIN',
  'CHECKOUT',
  'SELECT_PAYMENT',
  'ADD_PAYMENT',
  'CONFIRM',
  'SENT_MESSAGE',
  'MESSAGE',
  'SUCCESS',
  'WITHDRAW',
  'CONFIRMATION_WITHDRAW'
}
